module.exports = __webpack_public_path__ + "static/bedroom_top_left_night_mobile-e89308774212fd9121525ad270ed250a.jpg";